import { formatTime, useConnectionStore } from '@sentinel/web-core';
import { StateBadge, type StateTone } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';
import type { Me } from '@sentinel/shared';
import { initials } from './initials';

const TONE: Record<'online' | 'degraded' | 'offline', StateTone> = {
  online: 'ok',
  degraded: 'att',
  offline: 'crit',
};

/** Who is signed in: avatar, name, roles and organization, the state of the connection. */
export function UserHeader({ me }: { me: Me }) {
  const { t } = useTranslation();
  const link = useConnectionStore((s) => s.link());
  const roles = me.roles.map((r) => r.name).join(', ');
  const where = [roles, me.organization?.name].filter((s) => s !== undefined && s !== '');
  return (
    <div className="uc-hd">
      <span className="av" aria-hidden="true">
        {initials(me.displayName)}
      </span>
      <div>
        <p className="nm">{me.displayName}</p>
        <p>{me.email}</p>
        {where.length === 0 ? null : <p>{where.join(' · ')}</p>}
        {me.platformAccess === null ? null : (
          <p style={{ color: 'var(--att)' }}>
            {t('shell.user.platformAccess', { time: formatTime(me.platformAccess.expiresAt) })}
          </p>
        )}
        <StateBadge tone={TONE[link]} label={t(`shell.connection.${link}`)} />
      </div>
    </div>
  );
}
